
import React from "react";
import { Loader2 } from "lucide-react";

const AnalyzingIndicator: React.FC = () => {
  return (
    <div className="text-center p-4">
      <p>Running advanced 3D analysis using NVIDIA USD Search API...</p>
      <div className="flex justify-center mt-2">
        <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
      </div>
      <p className="text-sm text-gray-500 mt-2">
        Processing video frames and generating USD scene for analysis.
      </p>
      <p className="text-xs text-blue-500 mt-1">
        Results will be available for download as PDF.
      </p>
    </div>
  );
};

export default AnalyzingIndicator;
